<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="我的收藏">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>
        </div>
            <div class="tab-wrapper">
            	<div class="tab-item" @click="onClickItem(0)" v-bind:class="{'active':selected == 0}">收藏店铺<i class="icon"></i></div>
            	<div class="tab-item" @click="onClickItem(1)" v-bind:class="{'active':selected == 1}">收藏商品<i class="icon"></i></div>
             </div>
             <favorite-store v-if="selected==0"></favorite-store>
             <favorite-goods v-if="selected==1"></favorite-goods>
    </div>
</template>
<script>
import FavoriteGoods from './FavoriteGoods'
import FavoriteStore from './FavoriteStore'
export default {
  components: {
    FavoriteGoods,
    FavoriteStore
  },
  name: 'MemberFavorite',
  data () {
    return {
      selected: 0
    }
  },
  methods: {
	onClickItem(e) {
		if (this.selected !== e.currentIndex) {
			this.selected = e
		}
	},
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped lang="scss">
.container .tab-wrapper{margin-bottom:.5rem;height: 3rem;background: #fff;margin-top: .3rem;display: flex;align-items: center;}
.container .tab-wrapper .tab-item{width: 50%;display: flex;justify-content: center;font-size: .8rem;position: relative;}
.container .tab-wrapper .tab-item.active{color: $primaryColor;}
.container .tab-wrapper .tab-item.active .icon{position: absolute;width: 1rem;height: .2rem;background: $primaryColor;border-radius: 0.5rem;bottom: -.3rem;}
</style>
